import React from "react";
import Form from "react-bootstrap/Form";


const TableTypeDropDown = (props) => {

    return(
        <>

                <Form.Select onClick={(e)=>e.stopPropagation()} className="align-middle" aria-label="Sorting">
                    {props.items.map((item,index)=>
                        <option key={index} value={item}>{item}</option>
                    )}
                </Form.Select>
        </>
    )
}

export default TableTypeDropDown;